<template>
<div class="grid">
    <Loader v-if="loading" />
    <div class="col-12 lg:col-12 xl:col-12">
       
        <div class="card" id="printme" ref="printme" v-if="Application.application_id">
        <div class="container Application_container mt-4" >
            <div style="text-align: right;">
                <Button @click="back()"
                class="p-button-danger" label="Go Back" icon="pi pi-angle-double-left"/>
             </div>
            <h4><b>Application Details : </b></h4>
            <table class="table table-bordered" style="border: 1px solid black !important;">
                <tbody>
                    <tr>
                        <td><strong>Current Status :</strong> <span class="status-pending">{{Application.application_status_name}}</span></td>
                        <td><strong>Application ID :</strong><span class="status-pending">{{Application.application_id}}</span> </td>
                        <td><strong>Application For :</strong><span class="highlight">{{Applicationsurvey.Application_Type}}</span> </td>
                    </tr>
                    <tr>
                        <td><strong>Applicant Name :</strong> <span class="highlight">{{ Applicationsurvey.Applicant_name }}</span></td>
                        <td colspan="2"><strong>Agency Name :</strong> <span class="highlight">{{ Applicationsurvey.Agency_name }}</span></td>
                    </tr>
                    <tr>
                        <td width="40%"><strong>Address Of Applicant :</strong> <span class="highlight">{{ Applicationsurvey.Address_of_the_Applicant }}
                        </span></td>
                        <td><strong>Email :</strong> <span class="highlight">{{ userDetails.EmailID }}
                        </span></td>
                        <td><strong>MobileNo :</strong> <span class="highlight">{{ userDetails.MobileNo }}
                        </span></td>
                    </tr>
                    <tr>
                        <td><strong>PinCode :</strong> <span class="highlight">{{ Applicationsurvey.PinCode }}</span></td>
                        <td><strong>GST No :</strong> <span class="highlight">{{ userDetails.GST }}</span></td>
                        <td><strong>City :</strong> <span class="highlight">{{Applicationsurvey.Hoardingcity}}</span></td>
                    </tr>
                    <tr>
                        <td><strong>MunicipalCorporation :</strong> <span class="highlight">{{ Applicationsurvey.MunicipalCorporations }}</span></td>
                        <td><strong>District :</strong> <span class="highlight">{{ Applicationsurvey.District }}</span></td>
                        <td><strong>State :</strong> <span class="highlight">{{ Applicationsurvey.State }}</span></td>
                        
                        
                    </tr>
                    <tr v-if="Applicationsurvey.Application_Type=='Public Place'">
                        <td><strong>WorkOrder No :</strong> <span class="highlight">{{ Applicationsurvey.WorkOrder }}</span></td>
                        <td><strong>Licence From :</strong> <span class="highlight">{{ dateFormatDMY(Applicationsurvey.License_From) }}</span></td>
                        <td><strong>Licence Till :</strong> <span class="highlight">{{ dateFormatDMY(Applicationsurvey.Licence_Till) }}</span></td>
                        
                    </tr>
                    <tr v-if="Applicationsurvey.Application_Type=='Private Place'">
                        <td><strong>Owner Name :</strong> <span class="highlight">{{ Applicationsurvey.Owner_Name }}</span></td>
                        
                    </tr>
                    <tr>
                        <td><strong>Identity Proof :</strong> <span class="highlight">{{ Applicationsurvey.Identity_Proof }}</span></td>
                        <td colspan="2"><strong>Proof of possession of premises :</strong> <span class="highlight">{{ Applicationsurvey.Proof_of_Possession_of_premises }}</span></td>
                    </tr>
                    <!-- <tr>
                        <td colspan="3">
                            <strong>ज्या जमीनदार/इसमांतिवर आकाशविच प्रदशित करण्याचे प्रस्तावित आहे त्या जमीनिच्या/इसमांतिवे मालकांकडून घेतलेले ना हरकत प्रमाणपत्र :</strong> <span class="highlight">Yes</span><br />
                            <strong>ना हरकत प्रमाणपत्र :</strong> <a href="#" class="yes-upload">xxxxxxxxxxxx.pdf</a><br />
                            <strong>प्रॉपर्टी कार्ड :</strong> <a href="#" class="yes-upload">xxxxxxx.pdf</a>
                        </td>
                    </tr> -->
                </tbody>
            </table>
        </div>
        <div class="container Hoarding_container mt-4" v-if="Applicationsurvey.HoardingDetails">
            <h4><b>Hoarding Details : </b></h4>
            <table class="table table-bordered" style="border: 1px solid black !important;">
                <tbody>
                    <tr>
                        <td><strong>Hoarding Type :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['HoardingType'] }}</span></td>
                        <td colspan="2"><strong>Hoarding Name :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['HoardingName'] }}</span></td>
                    </tr>
                    <tr>
                        <td><strong>Owner Name :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['OwnerName'] }}</span></td>
                        <td><strong>Licensor Name :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['Licensor'] }}</span></td>
                        <td><strong>Advertizer Name :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['Advertizer'] }}</span></td>
                    </tr>
                    <tr>
                        <td width="40%"><strong>Hoarding Address :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['HoardingAddress'] }}</span></td>
                        <td><strong>Hoarding Height(ft) :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['Height'] }}</span></td>
                        <td><strong>Hoarding Width(ft) :</strong> <span class="highlight">{{ Applicationsurvey.HoardingDetails[0]['Width'] }}</span></td>
                       
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="container Document_container mt-4">
            <h4><b>Document Details : </b></h4>
            <div class="p-fluid formgrid grid" style="margin-top: 1%">
                <div class="field col-4 md:col-4">
                    <table class="table table-bordered" style="border: 1px solid black !important;">
                        <tbody>
                            <tr v-if="Applicationsurvey.Application_Type=='Public Place'">
                                <td colspan="4"><strong>1) WorkOrder :</strong> <span class="highlight">{{ Applicationsurvey['WorkOrder_doc'][0]['name'] }}</span></td>
                                <td>
                                    <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                            @click="ViewDOC(Applicationsurvey['WorkOrder_doc'][0]['content'])" />
                                </td>
                            </tr>
                            <tr v-if="Applicationsurvey.Application_Type=='Private Place'">
                                <td colspan="4"><strong>1) Owner Noc :</strong> <span class="highlight">{{ Applicationsurvey['Owner_noc_doc'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Owner_noc_doc'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>2) Identity Proof :</strong> <span v-if="Applicationsurvey['Identity_Proof_Doc']" class="highlight">{{ Applicationsurvey['Identity_Proof_Doc'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Identity_Proof_Doc']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Identity_Proof_Doc'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>3) Proof of Possession of premises :</strong> <span v-if="Applicationsurvey['Proof_of_Possession_of_premises_Doc']" class="highlight">{{ Applicationsurvey['Proof_of_Possession_of_premises_Doc'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Proof_of_Possession_of_premises_Doc']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Proof_of_Possession_of_premises_Doc'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>4) Proof of Possession of premises :</strong> <span v-if="Applicationsurvey['Partnership_Deed']" class="highlight">{{ Applicationsurvey['Partnership_Deed'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Partnership_Deed']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Partnership_Deed'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>5) Memorandum Association :</strong> <span v-if="Applicationsurvey['Memorandum_Association']" class="highlight">{{ Applicationsurvey['Memorandum_Association'][0]['name'] }}</span></td>
                                <td>
                                
                                    <Button v-if="Applicationsurvey['Memorandum_Association']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Memorandum_Association'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>6) Certificate Incorporation :</strong> <span v-if="Applicationsurvey['Certificate_Incorporation']" class="highlight">{{ Applicationsurvey['Certificate_Incorporation'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Certificate_Incorporation']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Certificate_Incorporation'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>7) Certificate issued by Charity Commissioner :</strong> <span v-if="Applicationsurvey['Certificate_issued_by_the_Charity_Commissioner']" class="highlight">{{ Applicationsurvey['Certificate_issued_by_the_Charity_Commissioner'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Certificate_issued_by_the_Charity_Commissioner']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Certificate_issued_by_the_Charity_Commissioner'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>8) Executive Engineer Building Proposal :</strong> <span v-if="Applicationsurvey['Executive_Engineer_Building_Proposal']" class="highlight">{{ Applicationsurvey['Executive_Engineer_Building_Proposal'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Executive_Engineer_Building_Proposal']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Executive_Engineer_Building_Proposal'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>9) Trafic Police NOC :</strong> <span v-if="Applicationsurvey['Trafic_Police_NOC']" class="highlight">{{ Applicationsurvey['Trafic_Police_NOC'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['Trafic_Police_NOC']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['Trafic_Police_NOC'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                        <td colspan="4"><strong>10) Hoarding image :</strong> <span v-if="Applicationsurvey.HoardingDetails" class="highlight">{{ Applicationsurvey.HoardingDetails[0]['Hoarding image'][0]['name'] }}</span></td>
                        <td>
                            <Button v-if="Applicationsurvey.HoardingDetails" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey.HoardingDetails[0]['Hoarding image'][0]['content'] )" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4"><strong>11) Undertaking :</strong> <span v-if="Applicationsurvey.HoardingDetails" class="highlight">{{ Applicationsurvey.HoardingDetails[0]['Undertaking'][0]['name'] }}</span></td>
                        <td>
                           <Button v-if="Applicationsurvey.HoardingDetails" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey.HoardingDetails[0]['Undertaking'][0]['content'] )" />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4"><strong>12) Permit certificate :</strong> <span v-if="Applicationsurvey.HoardingDetails" class="highlight">{{ Applicationsurvey.HoardingDetails[0]['Permit certificate'][0]['name'] }}</span></td>
                        <td>
                            <Button v-if="Applicationsurvey.HoardingDetails" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey.HoardingDetails[0]['Permit certificate'][0]['content'] )" />
                        </td>
                    </tr>
                        </tbody>
                    </table>
                </div>
                <div class="field col-8 md:col-8">
                    <iframe :src="`${file}#zoom=50`" style="width: 100%;height: 100%;border: none;" frameborder="0"></iframe>
                </div>
            </div>
        </div>
        </div>
        <!-- <div class="card">
            <div class="container-fluid" style="background-color: #e8f0f3">
                <div class="application-view" style="height: 500px;overflow: scroll;">
                    <div class="reg-form-box">
                        <div class="reg-form-body">

                            <div class="mb-3" v-for="(page, index) in applicationTemplate.pages" :key="index" style=" padding: 10px; color: blueviolet; width: 100%;">
                                <h6><b>{{ page.title }}</b></h6>
                                <div class="grid">
                                    <div class="col-12">
                                        <div class="grid" v-for="(element, ix) in page.elements" :key="ix" style="margin-top: 0px !important;">
                                            <div class="col-2" style="border: 0.1px solid rgb(199, 189, 189);color: rgb(8, 7, 7);" v-if="element.type != 'matrixdropdown'">
                                                <p>{{ element.title }}</p>
                                            </div>
                                            <div class="col-10" style="border: 0.1px solid rgb(197, 194, 194); color: rgb(115, 116, 117); font-size: 10px;" v-if="element.type != 'matrixdropdown'">
                                                <button v-if="element.type == 'file'" type="link" class="btn btn-warning" @click="view(element)">
                                                    view
                                                </button>
                                                <div v-if="element.type == 'paneldynamic'">

                                                    <DataTable :value="Applicationsurvey[element.name]">
                                                        <Column header="No">
                                                            <template #body="{ index }">
                                                                <span>{{ +index + +1 }}</span>

                                                            </template>
                                                        </Column>
                                                        <Column field="HoardingName" header="HoardingName">
                                                            <template #body="{ data }">
                                                                <span>{{ data.HoardingName }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="OwnerName" header="Owner Name">
                                                            <template #body="{ data }">
                                                                <span>{{ data.OwnerName }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="HoardingType" header="Type">
                                                            <template #body="{ data }">
                                                                <span>{{ data.HoardingType }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="Height" header="H x W">
                                                            <template #body="{ data }">
                                                                <span>{{ data.Height }} x {{ data.width }}</span>
                                                            </template>
                                                        </Column>
                                                        <Column field="HoardingAddress" header="Address">
                                                                                            <template #body="{ data }">
                                                                                                <span>{{ data.HoardingAddress }}</span>
                                                                                            </template>
                                                                                        </Column>
                                                        <Column field="Documents" header="Docs">
                                                            <template #body="{ data }">
                                                                <Button icon="pi pi-book" @click="documentshow(data['Hoarding image'])" v-tooltip.bottom="'View Documents'" />
                                                                                                &nbsp;
                                                                                                <Button icon="pi pi-book" @click="documentshow(data['Undertaking'])" v-tooltip.bottom="'View Documents'" />
                                                                                                &nbsp;
                                                                                                <Button icon="pi pi-book" @click="documentshow(data['Permit certificate'])" v-tooltip.bottom="'View Documents'" />
                                                            </template>
                                                        </Column>
                                                        

                                                    </DataTable>
                                                </div>
                                                <h6 v-else>{{ Applicationsurvey[element.name] }}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="card" v-if="App_LogHistory.length>0">
            <b>Application Log History :</b>
            <Divider />
            <table class="table" style="border: 1px solid black !important;width: 100%;">
                <tbody>
                    <tr v-for="(row, index) in App_LogHistory" :key="index">
                        <td><strong>Application Status :</strong> <span class="status-pending">{{row.StatusName?row.StatusName:'-'}}</span></td>
                        <td>
                            <strong v-if="row.RejectRemarks == 'New Application Generated'">Application Date</strong>
                            <strong v-else>Approve/Reject Date :</strong>
                             {{dateFormatDMY(row.CreatedDate)}}</td>
                        <td><strong>Remarks:</strong> 
                            <span class="Remarks">{{row.RejectRemarks?row.RejectRemarks:'-'}}</span>
                        </td>
                        
                        <td v-if="row.RejectionReason"><strong>Rejection Reason :</strong><span class="reject_reason">{{row.RejectionReason?row.RejectionReason:'-'}}</span> </td>
                    </tr>

                    
                    
                </tbody>
            </table>
        
        </div>
        
    </div>

    <div class="col-12 lg:col-12 xl:col-12">
        <div class="card" v-if="isApprovalAccess==true">
            <b>Application Approval :</b>
            <Divider />
            <div class="m-0">
                <div class="p-fluid formgrid grid">

                    <div class="field col-12 md:col-3" style="margin-top: 10px;">
                        <span class="p-float-label">
                            <Dropdown id="status" value-field="StatusID" v-model="Approve_selectstatus" :options="Approve_dropdownItems" :value="Approve_dropdownItems.StatusID" optionLabel="Status" @change.native="checkReject" required="true">
                            </Dropdown>
                            <label for="status">Approve Application</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-3" style="margin-top: 10px;" v-if="this.show">
                        <span class="p-float-label">
                            <Dropdown id="status" v-model="Reject_selectstatus" :options="Reject_dropdownItems" :value="Reject_dropdownItems.RejectionReasonID" optionLabel="RejectionReason" required="true"></Dropdown>
                            <label for="status">Reject Reason</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-3" style="margin-top: 10px;">
                        <Button icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" class="mr-2" />
                    </div>

                    <div class="field col-12 md:col-3" style="margin-top: 10px;"></div>

                    <div class="field col-12 md:col-12" style="margin-top: 10px;">
                        <span class="p-float-label">
                            <Textarea inputId="textarea" rows="4" cols="30" v-model="product.remark"></Textarea>
                            <label for="topic">Remark</label>
                        </span>
                    </div>
                </div>
            </div>

            <div class="m-0" style="text-align: center">
                <Button label="Primary" class="p-button-success p-button-Raised mr-2 mb-2" @click="Application_Approval">Submit</Button>
                <Button label="Primary" class="p-button-danger p-button-Raised mr-2 mb-2" @click="cancel">Back</Button>
            </div>

        </div>
    </div>

    <Dialog :v-model:visible="productdoc" modal :header="hoarding_title" :style="{ width: '60rem' }">
        <DataTable :value="doc">
            <Column header="No">
                <template #body="{ index }">
                    <span>{{ +index + +1 }}</span>

                </template>
            </Column>
            <Column field="HoardingName" header="Document">
                <template #body="{ data }">
                    <span>{{ data.name }}</span>
                </template>
            </Column>

            <Column field="Documents" header="Docs">
                <template #body="{ data }">
                    <Button icon="pi pi-eye" @click="viewdoc(data)" v-tooltip.bottom="'View Documents'" />

                </template>
            </Column>
        </DataTable>
    </Dialog>

</div>
</template>

<script>
import apis from "@/apis";
import axios from "axios";
import Loader from "../components/Loader.vue";
export default {
    name: "EdukattaGovermentAdminUIApplicationApproval",
    components: {
Loader	},
    data() {
        return {
            loading:false,
            isApprovalAccess: false,
            user_roll_id: "",
            hoarding_title: '',
            doc: [],
            productdoc: false,
            applicationTemplate: '',
            ApplicationDetails: "",
            Applicationsurvey: [],
            App_LogHistory: [],
            App_ReadRejectReason: [],
            App_RoleStatusMappingByAppStatus: [],
            product: {},
            Reject_selectstatus: null,
            Reject_dropdownItems: [],
            Approve_selectstatus: null,
            Approve_dropdownItems: [],
            show: false,
            file:'',
            Application:[],
            userDetails:[],
            from_page:"",
        };
    },
    async mounted() {
        var approval_flag = "";
        if (localStorage.getItem("flag")) {
            approval_flag = localStorage.getItem("flag");
        }
        if (localStorage.getItem("from_page")) {
            this.from_page = localStorage.getItem("from_page");
        }

        if (localStorage.getItem("applicationdata")) {
            this.ApplicationDetails = await JSON.parse(
                localStorage.getItem("applicationdata")
            );
            if (localStorage.getItem("surveydata")) {
                var temp = [];
                var survey = JSON.parse(localStorage.getItem("surveydata"));
                temp.push(JSON.parse(survey));
                //this.Applicationsurvey = temp[0];
            }

            localStorage.setItem("applicationdata", "");
            localStorage.setItem("surveydata", "");
            localStorage.setItem("flag", "");
            
        } else {
            this.$toast.add({
                severity: "error",
                summary: "Error!!!",
                detail: "Data Not Found",
                life: 3000,
            });
            this.$router.push({
                name: "ApplicationList"
            });
            return false;
        }

        if (approval_flag == 1) {
            await this.approval_access();
        }   
            await this.GET_getApplicationDetailsbyID();
            await this.Get_ApplicationTemplate();
            await this.Get_ApplicationLogHistory();
            await this.Get_ReadRejectReason();
            await this.Get_RoleStatusMappingByAppStatus();
    },
    methods: {
        ViewDOC(path)
        {       this.file = path;
                //window.open(path);
        },
        async GET_getApplicationDetailsbyID() {
            var application_id = this.ApplicationDetails["application_id"];
            var data = {
                application_id: application_id,
            };
            this.loading = true;
            var promise = apis.getApplicationDetailsbyID(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.status==true) {
                    this.Applicationsurvey = JSON.parse(response.data.data[0]['application_details']);
                    this.Application = response.data.data[0];
                    if (response.data.user_details.length>0) {
                      this.userDetails = response.data.user_details[0];
                    }
                }
                
            });
        },
        dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;

        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return date + "-" + month + "-" + year;
          }
        }
      }
      else {
        return "";
      }
    },
        async approval_access() {
            var data = {
                role_id: localStorage.getItem("user_role_id"),
                application_status: this.ApplicationDetails.application_status,
            };
            this.loading = true;
            var promise = apis.ApprovalAccess(data);
            promise.then((response) => {
                this.loading = false;
                this.isApprovalAccess = response.data.isApprovalAccess;
                
            });
            
        },



        async documentshow(doc) {
            window.open(doc[0]['content']);
        },
        async showdocs(data) {
            console.log(data);
            
            this.hoarding_title = data.HoardingName;
            this.doc = data.document;
            this.productdoc = true;
        },
        async viewdoc(data) {
            window.open(data.content)
        },
        checkReject(evt) {
            if (this.Approve_selectstatus.IsReject == 1) {
                this.show = true;
            } else {
                this.Reject_selectstatus = null;
                this.show = false;
            }
        },
        reset() {
            this.Approve_selectstatus = null;
            this.Reject_selectstatus = null;
            this.product.remark = '';
            this.show = false;
        },
        formatApplicationData(applicationData) {
            // Convert application_details back to JSON object
            const details = JSON.parse(applicationData.application_details);
            // Format application_details object
            const formattedDetails = JSON.stringify(details, null, 2);
            // Create a new object without application_details
            const newData = {
                ...applicationData
            };
            delete newData.application_details;
            // Combine formatted application_details with the rest of the data
            const formattedData = {
                ...newData,
                application_details: formattedDetails,
            };
            // Convert the combined object to a formatted JSON string
            const formattedString = JSON.stringify(formattedData, null, 2);
            return formattedString;
        },
        cancel() {
            this.$router.push({
                name: "ApplicationList"
            });
        },
        back() {
            this.$router.push({
                name: this.from_page
            });
        },
           //Date format
           D_M_Y_formatDate(date_parm) {
            if (date_parm) {
                let date = new Date(date_parm);
                let dd = date.getDate();
                let mm = date.getMonth() + 1;
                let yyyy = date.getFullYear();
                let new_date = dd + '-' + mm + '-' + yyyy;
                // alert(dd)
                if (dd.toString() != 'NaN') {
                    //this.receipt_new_date = new_date;
                    return new_date;
                } else {
                    return date_parm;
                }
            }
        },
        //LOG
        async Application_Approval() {
            if (!this.Approve_selectstatus) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Approve Application ",
          life: 3000
        });
        return false;
      }

     if(this.show)
     {
        if (!this.Reject_selectstatus) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Reject  Reason ",
          life: 3000
        });
        return false;
      }
    }

    if(this.show)
    {
      if(!this.product.remark)
      {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Remark ",
          life: 3000
        });
        return false;
      }
    }
            var application_id = this.ApplicationDetails["application_id"];
            var application_status = this.Approve_selectstatus.StatusID;
            var RejectReason = "";
            if (
                this.Reject_selectstatus ||
                this.Reject_selectstatus != undefined ||
                this.Reject_selectstatus != null
            ) {
                RejectReason = this.Reject_selectstatus.RejectionReasonID;
            }
            var RejectionRemarks = "";
            if (this.product.remark) {
                RejectionRemarks = this.product.remark;
            }
            var CreatedUser = localStorage.getItem("id");
            var data = {
                application_id: application_id,
                application_id: application_id,
                application_status: application_status ? application_status.toString() : '',
                RejectReason: RejectReason ? RejectReason.toString() : '',
                RejectionRemarks: RejectionRemarks,
                CreatedUser: "8E0245AD-D2FE-400F-9E0F-16651815998F",
            };
            this.loading = true;
            var promise = apis.ApplicationApproval(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.status == true) {
                    this.$swal(response.data.message);
                    this.$router.go(-1);
                } else {
                    this.$swal(response.data.message);
                }
            });
        },
        //LOG
        async Get_ApplicationLogHistory() {
            var application_id = this.ApplicationDetails["application_id"];
            var data = {
                application_id: application_id,
            };
            this.loading = true;
            var promise = apis.ApplicationLogHistory(data);
            promise.then((response) => {
                this.loading = false;
                this.App_LogHistory = response.data.data;
            });
        },
        //REJECT REASON
        async Get_ReadRejectReason() {
            var data = {};
            this.loading = true;
            var promise = apis.ReadRejectReason(data);
            promise.then((response) => {
                this.loading = false;
                this.Reject_dropdownItems = response.data.data;
            });
        },
        //GET STATUS
        async Get_RoleStatusMappingByAppStatus() {
            var data = {
                RoleID: localStorage.getItem("user_role_id"),
                ApplicationStatus: this.ApplicationDetails.application_status,
            };
            this.loading = true;
            var promise = apis.RoleStatusMappingByAppStatus(data);
            promise.then((response) => {
                this.loading = false;
                this.Approve_dropdownItems = response.data.data;
            });
        },
        //application template
        async Get_ApplicationTemplate() {
            var data = {
                "scheme_id": "123E4567-E89B-12D3-A456-426614174003"
            };

            var promise = apis.GetApplicationTemp(data);
            promise.then((response) => {

                this.applicationTemplate = JSON.parse(response.data.data[0]['application_template']);
            });
        },
        print() {
            window.print();
            //this.$htmlToPaper("printme");
        },
    },
};
</script>

<style>
.p-main-container {
    padding-top: 30px;
    background-color: #fff;
    padding-bottom: 30px;
}

.p-buttons-wrap {
    width: fit-content;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
}

table.b {
    table-layout: fixed;
    width: 500px;
}

.p-buttons-wrap button {
    color: #fff;
    background-color: #2e4b90;
    font-size: 13px;
    font-weight: bold;
    border: none;
    padding: 8px 20px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 4px;
}

.p-buttons-wrap button.btn-info:hover,
.p-buttons-wrap button.btn-info:active,
.p-buttons-wrap button.btn-info:visited,
.p-buttons-wrap button.btn-info:focus {
    background-color: #2e4b90 !important;
    color: #fff !important;
    border: none !important;
    outline: none !important;
}

.text-primary {
    font-size: 18px;
    color: #000 !important;
    margin-bottom: 20px;
    font-weight: bold;
}

table.profile-table {
    border: 0px solid #d3d3d3;
    width: 100%;
    text-align: left;
    border-collapse: collapse;
}

table.profile-table td,
table.profile-table th {
    border: 1px solid #d3d3d3;
    padding: 8px 15px;
}

table.table-3x td,
table.table-3x th {
    width: 33%;
}

table.profile-table td span.bold {
    font-weight: bold;
    font-size: 14px;
}

.bold {
    font-weight: bold;
    font-size: 14;
    color: #000;
}

table.profile-table tbody td {
    font-size: 13px;
    color: #000000;
}

table.doc-table {
    width: 10%;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
.table tr {
    height: 10px; /* Adjust the height as needed */
  }
  .table td {
    padding: 5px 10px; /* Increase padding for more spacing */
  }

/* .reg-form-box .reg-form-body {
  border: none;
  padding-top: 10px;
  padding-bottom: 0;
} */

.status-pending {
    color: purple;
    font-weight: bold;
}
.highlight {
    color: green;
    font-weight: bold;
}
.Remarks {
    color: green;
    font-weight: bold;
}
.no-upload {
    color: red;
}
.reject_reason {
    color: red;
}
.yes-upload {
    color: blue;
}
</style>
